<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Interior design",
    "pageDesc":"Helping brands have a consistent look and feel both online and offline with interior designs that suit their business functionalities.",
    "mantra":"Create your |branded decor. ",
    "mantraDesc":"As a multidisciplinary company, we support businesses in their way to success by providing a holistic collection of services. And to close the cycle with the branding services we provide, we take it one step further in execution to ensure that every signal is well communicated whether in wall colors, ground textures or chair shapes.",
    "sec1":"Let your place express who you are.",
    "sec1Items":{
      "1":{
        "title":"Branding driven",
        "desc":"We work with the brand guidelines to create an atmosphere that is stemming from the look and feel planned in the branding design phase."
      },
      "2":{
        "title":"Practical designs",
        "desc":"While working on the place interior, we utilize every inch to provide a functional usage for our end users and make the best use of space no matter how small it is."
      },
      "3":{
        "title":"Original work",
        "desc":"We don’t just follow the trend. Every pixel we make is custom made around your business and industry to match your brand personality and your usability."
      }
    },
    "sec2":"Covering you from chairs to walls.",
    "sec2Items":{
      "1":{
        "title":"Interior and exterior design",
        "desc":"From furniture design to the small space utilization, we do both the interior and exterior work for your business to help you stand out."
      },
      "2":{
        "title":"Furniture design",
        "desc":"Whether for office or a coffee shop, we help you with comfortable and unique pieces that makes that gets your visitors attention and positions you differently."
      },
      "3":{
        "title":"Reengineering and reconfiguration",
        "desc":"Adjusting your current space to suit your growth or brand facelift by customizing the layout and Doing the necessary changing for a better workflow."
      }
    },
    "cta":"Brand your <br> place today."
  },
  "ar": {
    "pageTitle":"التصميم الداخلي",
    "pageDesc":"نساعد مختلف العلامات التجارية في الحصول على مظهر مناسب ومتلائم سواء أونلاين أو أوفلاين من خلال تصميمات داخلية تناسب أعمالها المختلفة.",
    "mantra":"خطط لديكورات تناسب |علامتك التجارية. ",
    "mantraDesc":"كشركة متعددة التخصصات، ندعم الشركات خلال طريقها إلى النجاح من خلال توفير مجموعة شاملة من الخدمات. ليكون الأمر مكتملًا مع خدمات العلامات التجارية التي نقدمها، فإننا نتجه نحوالتنفيذ لضمان أن كل رسالة تصل بشكل مناسب سواء في ألوان الجدران  أوالأرضيات أو أشكال الكرسي.",
    "sec1":"اجعل مكانك يعبر عن هويتك",
    "sec1Items":{
      "1":{
        "title":"قائمة على العلامة التجارية",
        "desc":"عمل من خلال إرشادات العلامة التجارية لخلق جو قائم على المظهر والإنطباع المخطط  له في مرحلة تصميم العلامة التجارية."
      },
      "2":{
        "title":"تصاميم عملية",
        "desc":"نستخدم كل بوصة أثناء العمل في الأماكن الداخلية لاتباع كل السبل الوظيفية في المكان واستخدام المساحات بشكل أفضل بغض النظرعن صغر حجمها."
      },
      "3":{
        "title":"تصميمات أصلية",
        "desc":" لا نتبع الترندات فقط. كل بكسل نعمل عليه مصنوع خصيصًا لعملك وصناعتك لمطابقة شخصية علامتك التجارية وسهولة الاستخدام لديك."
      }
    },
    "sec2":"من الكراسي حتى الجدران",
    "sec2Items":{
      "1":{
        "title":"التصميم الداخلي والخارجي",
        "desc":"من تصميم الأثاث إلى استخدام المساحة الصغيرة، نقوم بالعمل الداخلي والخارجي لمساعدتك على التميز والاختلاف."
      },
      "2":{
        "title":"تصميم الأثاث",
        "desc":"سواء بالنسبة للمكتب أو في المقهى، نساعدك في الحصول على  قطع مريحة وفريدة من نوعها تجذب انتباه زوار موقعك."
      },
      "3":{
        "title":"إعادة الهندسة وإعادة التكوين",
        "desc":"نضبط المساحة الحالية الخاصة بك لتناسب توسعك فيما بعد أو حتى  لإجراء تغير على العلامة التجارية عن طريق تخصيص التصميم والقيام بالتغيير الضروري لسير عمل أفضل."
      }
    },
    "cta":"اجعل مكانك يتلائم مع <br> علامتك التجارية"
  }
}
</i18n>
